import { oc } from "@orpc/contract";
import { z } from "zod";

const arInvoiceEmailInput = z
  .object({
    invoiceId: z.string().uuid(),
    recipientEmails: z.array(z.string().email()).min(1),
    /**
     * Per-send override for the Microsoft Graph mailbox the email is sent
     * through. Falls back to the AR module config when omitted, then to
     * SendGrid when neither is set.
     */
    mailboxUpn: z.string().email().optional(),
    /** Optional visible From address; only honored when mailboxUpn is set. */
    senderAddress: z.string().email().optional(),
  })
  .refine((value) => !value.senderAddress || !!value.mailboxUpn, {
    message: "senderAddress requires mailboxUpn",
    path: ["senderAddress"],
  });

export const arInvoiceEmailContracts = {
  preview: oc
    .input(arInvoiceEmailInput)
    .output(
      z.object({
        from: z.string(),
        to: z.string(),
        cc: z.array(z.string()),
        subject: z.string(),
        htmlContent: z.string(),
        pdfBase64: z.string(),
      }),
    )
    .route({ method: "POST" }),

  send: oc
    .input(arInvoiceEmailInput)
    .output(z.object({ outboundEmailId: z.string().uuid() }))
    .route({ method: "POST" }),
} as const;
